import { render, staticRenderFns } from "./zhezhao.vue?vue&type=template&id=08ff0d16&scoped=true"
import script from "./zhezhao.vue?vue&type=script&lang=js"
export * from "./zhezhao.vue?vue&type=script&lang=js"
import style0 from "./zhezhao.vue?vue&type=style&index=0&id=08ff0d16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ff0d16",
  null
  
)

export default component.exports